export const SET_DATA_MARKER = 'SET_DATA_MARKER';
export const SET_TYPE_MARKER = 'SET_TYPE_MARKER';
export const SET_DATA_POLYGON = 'SET_DATA_POLYGON';
export const SET_POSTS = 'SET_POSTS';
